"use client";

import React from "react";
import TikTokChallenge from "./TikTokChallenge";
import { useAppStore } from "@/store/useAppStore";
import { useAuth } from "@/hooks/useAuth";
import { updateUserScore } from "@/lib/user/updateUserScore";
import { addChallengeActivity } from "@/lib/activity/addActivityToDB";

export const TikTokMode = () => {
  const { user } = useAuth();
  const { showTikTokMode, setShowTikTokMode, updateUserPointsScore } =
    useAppStore();

  const onCompleteClick = async (points: number) => {
    try {
      updateUserPointsScore(points);
      if (user?.id) {
        await updateUserScore(user.id, points);
      }
      await addChallengeActivity(points);
      setShowTikTokMode(false);
      alert(`🎉 TikTok Challenge Complete! +${points} points!`);
    } catch (error) {
      console.log("Failed to complete TikTok Challenge");
    }
  };

  if (!showTikTokMode) {
    return null;
  }
  return <TikTokChallenge onComplete={onCompleteClick} />;
};
